export default "__VITE_ASSET__DW9hR3vW__"